import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoData = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 150,
	height: 87,
	viewBox: "0 0 150 87",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M143.713 18C147.185 18 150 20.2833 150 23.1C150 25.9167 147.185 28.2 143.713 28.2H107.784C111.257 28.2 114.072 30.4833 114.072 33.3C114.072 36.1167 111.257 38.4 107.784 38.4H127.545C131.017 38.4 133.832 40.6833 133.832 43.5C133.832 46.3167 131.017 48.6 127.545 48.6H118.407C114.028 48.6 110.479 50.8833 110.479 53.7C110.479 55.5778 112.275 57.2778 115.868 58.8C119.341 58.8 122.156 61.0833 122.156 63.9C122.156 66.7167 119.341 69 115.868 69H41.3174C37.8449 69 35.0299 66.7167 35.0299 63.9C35.0299 61.0833 37.8449 58.8 41.3174 58.8H6.28743C2.81498 58.8 0 56.5167 0 53.7C0 50.8833 2.81498 48.6 6.28743 48.6H42.2156C45.688 48.6 48.503 46.3167 48.503 43.5C48.503 40.6833 45.688 38.4 42.2156 38.4H19.7605C16.288 38.4 13.4731 36.1167 13.4731 33.3C13.4731 30.4833 16.288 28.2 19.7605 28.2H55.6886C52.2162 28.2 49.4012 25.9167 49.4012 23.1C49.4012 20.2833 52.2162 18 55.6886 18H143.713ZM143.713 38.4C147.185 38.4 150 40.6833 150 43.5C150 46.3167 147.185 48.6 143.713 48.6C140.24 48.6 137.425 46.3167 137.425 43.5C137.425 40.6833 140.24 38.4 143.713 38.4Z",
			fill: "#F4F4F4"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M95.3499 10.6261L102.629 63.7133L103.283 69.0393C103.493 70.7551 102.273 72.3168 100.557 72.5274L54.7337 78.1539C53.018 78.3645 51.4563 77.1444 51.2456 75.4287L44.1907 17.9713C44.0854 17.1134 44.6955 16.3326 45.5533 16.2272C45.5588 16.2266 45.5642 16.2259 45.5696 16.2253L49.3713 15.7989M52.4438 15.4545L56.0332 15.0519L52.4438 15.4545Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M96.0929 10.5243C96.0367 10.1139 95.6584 9.82682 95.248 9.88309C94.8376 9.93936 94.5506 10.3176 94.6068 10.728L95.3499 10.6261L96.0929 10.5243ZM102.629 63.7133L103.373 63.6219L103.372 63.6115L102.629 63.7133ZM103.283 69.0393L104.027 68.9479L103.283 69.0393ZM100.557 72.5274L100.649 73.2719L100.557 72.5274ZM54.7337 78.1539L54.8251 78.8983L54.7337 78.1539ZM51.2456 75.4287L51.99 75.3372L51.2456 75.4287ZM44.1907 17.9713L43.4463 18.0627L44.1907 17.9713ZM45.5696 16.2253L45.6532 16.9707L45.5696 16.2253ZM49.4549 16.5442C49.8665 16.498 50.1628 16.1269 50.1166 15.7153C50.0705 15.3036 49.6993 15.0074 49.2877 15.0536L49.3713 15.7989L49.4549 16.5442ZM52.3602 14.7092C51.9486 14.7554 51.6523 15.1265 51.6985 15.5381C51.7447 15.9498 52.1158 16.246 52.5274 16.1999L52.4438 15.4545L52.3602 14.7092ZM56.1168 15.7972C56.5284 15.7511 56.8247 15.3799 56.7785 14.9683C56.7324 14.5567 56.3612 14.2604 55.9496 14.3066L56.0332 15.0519L56.1168 15.7972ZM95.3499 10.6261L94.6068 10.728L101.886 63.8152L102.629 63.7133L103.372 63.6115L96.0929 10.5243L95.3499 10.6261ZM102.629 63.7133L101.884 63.8047L102.538 69.1307L103.283 69.0393L104.027 68.9479L103.373 63.6219L102.629 63.7133ZM103.283 69.0393L102.538 69.1307C102.698 70.4354 101.771 71.6228 100.466 71.783L100.557 72.5274L100.649 73.2719C102.776 73.0107 104.288 71.0748 104.027 68.9479L103.283 69.0393ZM100.557 72.5274L100.466 71.783L54.6423 77.4095L54.7337 78.1539L54.8251 78.8983L100.649 73.2719L100.557 72.5274ZM54.7337 78.1539L54.6423 77.4095C53.3377 77.5697 52.1502 76.6419 51.99 75.3372L51.2456 75.4287L50.5012 75.5201C50.7623 77.647 52.6982 79.1594 54.8251 78.8983L54.7337 78.1539ZM51.2456 75.4287L51.99 75.3372L44.9351 17.8799L44.1907 17.9713L43.4463 18.0627L50.5012 75.5201L51.2456 75.4287ZM44.1907 17.9713L44.9351 17.8799C44.8803 17.4331 45.198 17.0265 45.6447 16.9717L45.5533 16.2272L45.4619 15.4828C44.1929 15.6386 43.2905 16.7937 43.4463 18.0627L44.1907 17.9713ZM45.5533 16.2272L45.6447 16.9717C45.6476 16.9713 45.6504 16.971 45.6532 16.9707L45.5696 16.2253L45.486 15.48C45.478 15.4809 45.47 15.4818 45.4619 15.4828L45.5533 16.2272ZM45.5696 16.2253L45.6532 16.9707L49.4549 16.5442L49.3713 15.7989L49.2877 15.0536L45.486 15.48L45.5696 16.2253ZM52.4438 15.4545L52.5274 16.1999L56.1168 15.7972L56.0332 15.0519L55.9496 14.3066L52.3602 14.7092L52.4438 15.4545Z",
			fill: "#C2C2C2"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M93.3703 13.9673L99.9586 62.0786L100.551 66.9052C100.742 68.4602 99.6513 69.8736 98.1148 70.0623L57.0788 75.1009C55.5422 75.2895 54.1419 74.1819 53.951 72.627L47.6266 21.1189C47.4919 20.0225 48.2716 19.0247 49.3679 18.8901L54.0127 18.3197",
			fill: "#FAFAFA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M62 0.75H96.8633C97.7211 0.75 98.5445 1.08905 99.1533 1.69336L109.29 11.7559C109.904 12.3659 110.25 13.1958 110.25 14.0615V62C110.25 63.7949 108.795 65.25 107 65.25H62C60.2051 65.25 58.75 63.7949 58.75 62V4C58.75 2.20507 60.2051 0.75 62 0.75Z",
			fill: "white",
			stroke: "#C2C2C2",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M98 1V10.5338C98 11.8958 98.9828 13 100.195 13H106",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67 53H87.5581M67 13H87.5581H67ZM67 22.4118H101H67ZM67 32.6078H101H67ZM67 42.8039H101H67Z",
			stroke: "#B6B6B6",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d_25416_3518)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M114.387 72.8966C112.942 73.7909 111.291 74.6164 109.778 75.1667C105.926 76.405 101.867 76.3362 98.0144 75.0979C94.0932 73.7909 90.4472 71.2455 88.0394 67.4619C82.2608 58.6564 84.7374 46.824 93.5429 41.0454C102.348 35.2668 114.181 37.6058 119.891 46.4801C121.954 49.6445 122.917 53.2218 123.055 56.9366C123.055 63.4031 119.753 69.4569 114.387 72.8966Z",
				fill: "#C2C2C2"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M111.212 61.17L107.184 57.1421L111.212 53.1143C112.017 52.3087 112.107 50.9661 111.212 50.0711C110.406 49.2655 109.064 49.176 108.168 50.0711L104.141 54.0989L100.113 50.0711C99.3072 49.2655 97.9646 49.176 97.0696 50.0711C96.1745 50.9661 96.1745 52.2192 97.0696 53.1143L101.097 57.1421L97.0696 61.17C96.264 61.9755 96.1745 63.3181 97.0696 64.2132C97.8751 65.0188 99.2177 65.1083 100.113 64.2132L104.141 60.1854L108.168 64.2132C108.974 65.0188 110.317 65.1083 111.212 64.2132C112.107 63.3181 112.017 61.9755 111.212 61.17Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d_25416_3518",
			x: 76.918,
			y: 31.8848,
			width: 54.1367,
			height: 54.1768,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 2 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 4 }),
				/* @__PURE__ */ _jsx("feComposite", {
					in2: "hardAlpha",
					operator: "out"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.815686 0 0 0 0 0.815686 0 0 0 0 0.815686 0 0 0 1 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow_25416_3518"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow_25416_3518",
					result: "shape"
				})
			]
		}) })
	]
});
export default SvgNoData;
